<template>
  <div class="OrderSelect-container">
    <el-select
      v-model="value"
      :disabled="disabled"
      ref="select"
      placeholder="请选择订单，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchOrder"
      :style="tcfstyle"
      @change="openDetails"
      @clear="clearSelect">
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%">
          <el-table-column
            label="订单号"
            width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">订单号：</span>
              <span> {{scope.row.ordernum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="生产单号"
            width="150"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">生产单号：</span>
              <span>{{scope.row.produnum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="详细地址"
            min-width="200"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">详细地址：</span>
              <span> {{scope.row.address}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-select>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderMarkList, getOrderById } from '@/api/erp'

export default {
  name: 'OrderChoose',
  computed: {
    user: getUser
  },
  props: {
    oldorderid: {
      type: String
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    },
    delid: {
      type: String
    },
    mark: {
      type: Number
    },
    disabled: {
      type: Boolean
    }
  },
  watch: {
    delid(newVal) {
      if (newVal) {
        this.clearSelect()
        this.searchOrder('')
      }
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: ''
    }
  },
  created() {
    this.getData()
    if (this.oldorderid !== null && this.oldorderid !== '' && this.oldorderid !== undefined) {
      getOrderById({ orderid: this.oldorderid }).then(response => {
        this.value = response.data.orderid
        this.changeLabel = response.data.ordernum + ' / ' + response.data.produnum + ' / ' + response.data.address
        this.$emit('input', this.value)
      }).catch(() => {})
    }
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        content: this.filterText,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.delid,
        mark: this.mark,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      getOrderMarkList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', this.value)
    },
    searchOrder(val) {
      this.filterText = val
      this.currentPage = 1
      this.getData()
    },
    openDetails(data) {
      this.value = data.orderid
      this.changeLabel = data.ordernum + ' / ' + data.produnum + ' / ' + data.address
      this.$emit('input', this.value)
      this.$emit('setOrder', data)
      this.$refs.select.blur()
    }
  }
}
</script>
<style lang="scss" scoped>
  .OrderSelect-container{
    .el-table::before{
      height: 0!important;
    }
    .el-pagination{
      margin-top: 20px;
    }
  }
</style>
